




import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

import Compositions from '@/store/compositions.ts'

const compositions = getModule(Compositions)

@Component
export default class StoreJSON extends Vue {
  // props
  @Prop({ default: {} }) readonly json!: any

  get jsonString () {
    return JSON.stringify(this.json, null, 2)
  }
}

